/* =============================================================================
   Plants by Frank — Brand JS
   ============================================================================= */

/* --- Cart: gratis verzending progress bar --- */

const PBF_SHIPPING_THRESHOLD = 5000; // €50,00 in centen

function pbfUpdateShippingBar(cartTotal) {
  const bar = document.querySelector('.pbf-shipping-bar');
  if (!bar) return;

  const fill = bar.querySelector('.pbf-shipping-bar__fill');
  const text = bar.querySelector('.pbf-shipping-bar__text');
  if (!fill || !text) return;

  const remaining = PBF_SHIPPING_THRESHOLD - cartTotal;
  const pct = Math.min(100, Math.round((cartTotal / PBF_SHIPPING_THRESHOLD) * 100));

  fill.style.width = pct + '%';

  if (cartTotal >= PBF_SHIPPING_THRESHOLD) {
    bar.classList.remove('pbf-shipping-bar--empty');
    text.textContent = '🎉 Je hebt gratis verzending!';
    text.classList.add('pbf-shipping-bar__text--success');
  } else {
    bar.classList.remove('pbf-shipping-bar--empty');
    text.classList.remove('pbf-shipping-bar__text--success');
    const euros = (remaining / 100).toFixed(2).replace('.', ',');
    text.textContent = `Nog €${euros} voor gratis verzending`;
  }
}

// Luister naar cart updates (Shopify publishes 'cart:refresh' en custom events)
document.addEventListener('DOMContentLoaded', function () {
  // Initialiseer op basis van data-attribuut dat de server rendert
  const bar = document.querySelector('.pbf-shipping-bar');
  if (bar) {
    const total = parseInt(bar.dataset.cartTotal || '0', 10);
    pbfUpdateShippingBar(total);
  }
});

// Dawn publiceert 'cart:refresh' en 'cart:update' via pubsub
if (typeof subscribe === 'function') {
  subscribe('cart:refresh', function (cart) {
    if (cart && typeof cart.total_price !== 'undefined') {
      pbfUpdateShippingBar(cart.total_price);
    }
  });
}

// Fallback: MutationObserver op cart-drawer voor herrendering
const cartDrawer = document.querySelector('#CartDrawer');
if (cartDrawer) {
  new MutationObserver(function () {
    const bar = cartDrawer.querySelector('.pbf-shipping-bar');
    if (bar) {
      const total = parseInt(bar.dataset.cartTotal || '0', 10);
      pbfUpdateShippingBar(total);
    }
  }).observe(cartDrawer, { childList: true, subtree: true });
}
